import React from 'react';

const ProfilePage = () => {
    return (
        <div>
            <p>Profile page.</p>
        </div>
    );
};

export default ProfilePage;
